import {
  addHours,
  addMilliseconds,
  addMinutes,
  addSeconds,
  differenceInHours,
  differenceInMilliseconds,
  differenceInMinutes,
  differenceInSeconds,
  format,
} from 'date-fns'

import getJWT from './get-jwt'
import translateResponseError from './translate-response-error'
import trimData from './trim-data'
import drawNumberLabel from './draw-number-label'
import prependProtocolToURL from './prepend-protocol-to-url'
import pagesNavigation from './pages-navigation'
import { isLabel, isRole, isUser } from './determine-user'
import replace from './string-replace'
import guard from './guard'
import { computeQuadrantColor, computeQuadrantColorName, MOOD_METER_COLORS } from './mood-meter'
import stripHtmlTags from './strip-html-tags'

export const SCROLL_OPTIONS = {
  duration: 200,
  smooth: true,
}

export const cityWithCounty = (city: string, county?: string): string =>
  `${city}${county ? `, ${county}` : ''}`

export {
  format,
  addHours,
  addMilliseconds,
  addMinutes,
  addSeconds,
  differenceInHours,
  differenceInMilliseconds,
  differenceInMinutes,
  differenceInSeconds,
  getJWT,
  translateResponseError,
  trimData,
  drawNumberLabel,
  prependProtocolToURL,
  pagesNavigation,
  isLabel,
  isRole,
  isUser,
  replace,
  guard,
  computeQuadrantColor,
  computeQuadrantColorName,
  MOOD_METER_COLORS,
  stripHtmlTags,
}

export const formatDuration = (timeInt: number): string => {
  const base = new Date(0 + new Date().getTimezoneOffset() * 60000)
  const date = addMilliseconds(base, timeInt)
  return format(date, 'HH:mm:ss')
}

interface TimeDurationResult {
  asSeconds: () => number
  asMinutes: () => number
  asHours: () => number
  asMilliseconds: () => number
}

export const timeDuration = (timeString: string | null | undefined): TimeDurationResult => {
  const [hours = 0, minutes = 0, seconds = 0] = timeString
    ? timeString.split(':').map(Number)
    : [0, 0, 0]
  const base = new Date(0 + new Date().getTimezoneOffset() * 60000)
  const date = addHours(addMinutes(addSeconds(base, seconds), minutes), hours)
  return {
    asSeconds: () => differenceInSeconds(date, base),
    asMinutes: () => differenceInMinutes(date, base),
    asHours: () => differenceInHours(date, base),
    asMilliseconds: () => differenceInMilliseconds(date, base),
  }
}

export const parseJwt = (token: string): Record<string, unknown> => {
  try {
    if (typeof token !== 'string' || !token) return {}
    return JSON.parse(window.atob(token.split('.')[1])) as Record<string, unknown>
  } catch {
    return {}
  }
}

export const replaceS3path = (url: string): string => {
  try {
    return `/api/media${new URL(url).pathname}`
  } catch {
    return `/api/media${url}`
  }
}

export const replaceMediaLinksInContent = (content: string): string => {
  const urlPattern =
    /"https:\/\/(ruleronlineimgs.)?s3.amazonaws.com\/(ruleronlineimgs\/)?media\/.*?\.(pdf|pptx|docx)\??.*?"/g
  return content.replace(urlPattern, (match) => {
    return `"${replaceS3path(match.slice(1, -1).replace('ruleronlineimgs/', ''))}"`
  })
}
